/**
 * Chart configurations for different visualization components
 */

// CryptoMarkets chart data
export const cryptoMarketsData = [
  { country: "País 1", value: 100000 },
  { country: "País 2", value: 90000 },
  { country: "País 3", value: 80000 },
  { country: "País 4", value: 70000 },
  { country: "Brasil", value: 60000 },
  { country: "País 6", value: 50000 },
  { country: "País 7", value: 40000 },
  { country: "País 8", value: 30000 },
  { country: "País 9", value: 20000 },
  { country: "País 10", value: 10000 }
];

// CryptoMarkets chart options
export const cryptoMarketsOptions = {
  backgroundColor: '#4CAF50', // Green background
  barColor: '#f5f5f5',        // Light color for regular bars
  highlightColor: '#333333',  // Dark color for highlighted bar (Brasil)
  highlightCountry: 'Brasil', // Country to highlight
  margin: { top: 50, right: 30, bottom: 50, left: 80 }
};

// ScatterPlot chart options
export const scatterPlotOptions = {
  backgroundColor: '#6366f1', // Indigo background
  gridColor: 'rgba(255, 255, 255, 0.2)',
  textColor: '#ffffff',
  pointRadius: 6,
  hexbinRadius: 10,
  hexbinOpacity: 0.7
};

// Add more chart configurations as needed
export const chartConfigs = {
  cryptoMarkets: {
    title: "Crypto Markets",
    description: "Bar chart showing crypto market sizes by country",
    component: "CryptoMarkets",
    data: cryptoMarketsData,
    options: cryptoMarketsOptions,
    visible: true
  },
  dataVisualization: {
    title: "Data Visualization",
    description: "Interactive visualization with filters",
    component: "DataVisualization",
    visible: true
  },
  scatterPlot: {
    title: "Deputados Performance",
    description: "Interactive scatter plot showing deputies performance metrics",
    component: "ScatterPlot",
    options: scatterPlotOptions,
    visible: true
  }
  // Add more chart configurations here
};
